<template>
    <div>
      <h2>직원관리</h2>
      <p>
        Tens에듀는 수업하는 선생님을 직원관리를 통하여 미리 등록하여 사용합니다.<br/>
        설정>직원관리 메뉴에서 선생님을 관리합니다.<br/>
      </p>
      
      <section>
        <div class="p-relative section_0" id="add_teacher">
            <div class="ft-b">1)    직원추가</div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/setting/setting_teacher_add.jpg" /></div>
            </div>
        
            <div class="p-relative section_1">
                -   “추가”버튼을 클릭하면 “직원” 다이알로그가 나타납니다.
            </div>
            
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/setting/setting_teacher_modal.jpg" /></div>
            </div>
            <div class="p-relative section_2">
                선생님의 기본정보를 입력 후 “저장”합니다.
            </div>
            
        </div>

      </section>

      <q-drawer show-if-above side="right" class="bg-white">
          <q-list>
            <q-item-label header style="padding:40px 42px 20px;">바로가기</q-item-label>
            <li class="q-px-lg pointer" 
                      v-for="m in menuItems" 
                      :key="m.label"
                      @click="goTo(m.link)" >
                {{m.label}}
            </li>
            
          </q-list>
      </q-drawer>
    </div>
</template>

<script>
import goto from "./goto.js";
export default {
    components : {
    },
    data : function() {
        return {
            menuItems: [
                { label: '직원추가', link: '#add_teacher' },
                
            ]
        }
    },
    computed :{
    },
    methods : {
        goTo(link) {
            goto.goto_link(link);
        }
    },
    beforeMount() {
        goto.clear();
    }
}
</script>


